<template>
  <div clas="row">
    <page-header :actions="headerActionsConfig" :page="headerConfig" />
    <BudgetManagementServices
      v-if="budgetSwitch"
      @on-cancel="onCancelHandler"
      @on-save="onSaveBudgetHandler($event)"
    />
    <filter-manager
      v-model="filterModel"
      class="mb-4"
      :display-advanced="false"
      :filters="filtersConfig"
      @search="onSearch"
    />
    <custom-separator class="my-4" text="Resultados de Búsqueda" />
    <custom-result-not-found v-if="results.length == 0" />
    <result-row
      v-for="(row, idx) of results"
      :key="`result-${idx}`"
      class="mb-3"
      :data="row"
      @on-budget-adjusted="onBudgetAdjustedHandler($event)"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import ResultRow from './components/ResultRow.vue';
import BudgetManagementServices from './components/BudgetManagmentServices.vue';
import CustomResultNotFound from 'custom-result-not-found';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import {
  getAllAcademicYearsForBudget as _getAllAcademicYearsForBudget,
  getBudgetData as _getBudgetData,
  addBudget as _addBudget,
} from '@/views/support/modules/shared/budget.api.js';
const STORE_MODULE_NAME = 'BudgetManagement';

export default {
  name: 'BudgetManagement',
  mixins: [alertMixin],
  components: {
    PageHeader,
    CustomResultNotFound,
    FilterManager,
    BudgetManagementServices,
    ResultRow,
    CustomSeparator,
  },
  data: () => ({
    moduleName: STORE_MODULE_NAME,
    filterModel: {
      academicYear: null,
    },
    academicYears: [],
    results: [],
    budgetSwitch: false,
  }),
  computed: {
    headerConfig() {
      return {
        icon: 'fas fa-clipboard-list',
        title: 'Presupuesto',
        routes: ['Inicio', 'USPQRP', 'Presupuesto'],
      };
    },
    headerActionsConfig() {
      return [
        {
          text: 'Añadir',
          icon: 'fas fa-file-plus fa-lg mr-1',
          variant: 'success ml-0 mb-3',
          visible: !this.budgetSwitch,
          click: () => this.onAddHandler(),
        },
      ];
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.academicYears,
          placeholder: 'Año Académico',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
        },
      ];
    },
  },
  async mounted() {
    await this.initFilters();
    await this.onSearch();
  },
  methods: {
    async initFilters() {
      const { data } = await _getAllAcademicYearsForBudget();
      this.academicYears = data;
    },
    async onSearch() {
      const { data } = await _getBudgetData(this.filterModel.academicYear?.id);
      this.results = data;
    },
    onAddHandler() {
      this.budgetSwitch = true;
    },
    onCancelHandler() {
      this.budgetSwitch = false;
    },
    async onSaveBudgetHandler(item) {
      const payload = {
        academicYearId: item.academicYear.id,
        amount: Number.parseFloat(item.amount),
      };

      await _addBudget(payload)
        .then(({ data }) => {
          this.ShowToast(
            'Proceso exitoso.',
            'El presupuesto se ha añadido exitosamente.',
            'success'
          );
          this.budgetSwitch = false;
          this.filterModel.academicYear = this.academicYears.find(
            (x) => x.id == data.academicYearId
          );
          this.onSearch();
        })
        .catch((err) =>
          this.ShowToast(
            'Alerta',
            err?.response.data.message || 'error',
            'error'
          )
        );
    },
    onBudgetAdjustedHandler(item) {
      this.filterModel.academicYear = this.academicYears.find(
        (x) => x.id == item.academicYearId
      );
      this.onSearch();
    },
  },
};
</script>
